import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import SideMenu from '../../components/SideMenu/SideMenu';
import SideMenuMobile from '../../components/SideMenuMobile/SideMenuMobile';
import { setIdentityAPIToken } from '../../config/api';
import { MouseActivityProvider } from '../../providers/Inactivity/MouseActivityProvider';
import { selectUsuario } from '../../redux/features/generalData/generalDataSelectors';
import useApplicationLayout from './hooks/useApplicationLayout';

const ApplicationLayout = (): JSX.Element => {
  const { menuColapsed, setMenuColapsed } = useApplicationLayout();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const user = useSelector(selectUsuario);

  setIdentityAPIToken(user?.accessToken?.token ?? '');

  useEffect(() => {
    const checkIfMobile = (): void => {
      setIsMobile(window.matchMedia('(max-width: 1024px)').matches);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  if (isMobile) {
    return (
      <div id="cointainer" className="flex h-full flex-col bg-foreground-50">
        <Navbar isMobile onMenuToggle={setMenuColapsed} />

        <div className="flex h-full max-h-[calc(100%-64px)] bg-foreground-50">
          <SideMenuMobile
            setMenuColapsed={setMenuColapsed}
            isOpen={!menuColapsed}
          />

          {menuColapsed && (
            <div
              className={`w-full overflow-auto bg-background ${
                location.pathname.includes('criar-rota') ? '' : 'px-12 pt-8'
              }`}
            >
              <Outlet />
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <MouseActivityProvider>
      <div id="cointainer" className="flex h-full flex-col bg-foreground-50">
        <Navbar onMenuToggle={setMenuColapsed} />

        <div className="flex h-full max-h-[calc(100%-64px)] bg-foreground-50">
          <SideMenu isOpen={!menuColapsed} />

          <div
            className={`w-full overflow-auto rounded-tl-2xl border-l border-t border-foreground-300 bg-background ${
              location.pathname.includes('criar-rota') ? '' : 'px-12 pt-8'
            }`}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </MouseActivityProvider>
  );
};

export default ApplicationLayout;
